import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import type { TextButtonProps } from "@/types";
import { useMargins } from "@/hooks";
import { Icon, Typography } from "@/components/common/display";


/**
 * A generic text button.
 */
const __default__ = {
  name: "TextButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    text: { type: Boolean },
    block: { type: Boolean },
    percentage: {},
    label: {},
    hideLabel: { type: Boolean },
    iconRotate: {},
    icon: {},
    disabled: { type: Boolean },
    color: {},
    loading: { type: Boolean },
    x: {},
    y: {},
    l: {},
    r: {},
    t: {},
    b: {},
    class: {},
    small: { type: Boolean },
    large: { type: Boolean },
    outlined: { type: Boolean },
    dataCy: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const buttonClassName = useMargins(props, () => [
  ["color", `text-${props.color}`],
  ["block", "full-width"],
  ["class", props.class],
]);

const buttonColor = computed(() => {
  switch (props.icon) {
    case "add":
    case "save":
      return "primary";
    case "delete":
      return "negative";
    default:
      return props.color;
  }
});

const buttonSize = computed(() => {
  if (props.large) {
    return "lg";
  } else if (props.small) {
    return "sm";
  } else {
    return undefined;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    disable: props.disabled,
    size: buttonSize.value,
    outline: props.outlined,
    flat: props.text,
    loading: props.loading,
    percentage: props.percentage,
    color: buttonColor.value,
    class: _normalizeClass(_unref(buttonClassName)),
    "data-cy": props.dataCy,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      (props.icon)
        ? (_openBlock(), _createBlock(_unref(Icon), {
            key: 0,
            variant: props.icon,
            class: _normalizeClass(!props.hideLabel ? 'q-mr-sm' : ''),
            rotate: props.iconRotate
          }, null, 8, ["variant", "class", "rotate"]))
        : _createCommentVNode("", true),
      (!!props.label && !props.hideLabel)
        ? (_openBlock(), _createBlock(_unref(Typography), {
            key: 1,
            value: props.label,
            small: props.small,
            large: props.large
          }, null, 8, ["value", "small", "large"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["disable", "size", "outline", "flat", "loading", "percentage", "color", "class", "data-cy"]))
}
}

})